import fetch from '~/common/fetch'

export const wizardsApi = {
  getByPlacement: placement => fetch.get(`/api/v2/ava/wizards?placement=${placement}`)
}
